/* -------------------------------------------

	Name:		La Moda
	Date:		2019/03/01
	Author:		http://psdhtml.me

---------------------------------------------  */
/*global jQuery, document, yall, setTimeout, Cookies, window */
var i = 0,
  img_lazy = document.querySelectorAll('img[data-src]:not(.dont)');
for (i = 0; i < img_lazy.length; i = i + 1) {
  img_lazy[i].classList.add('lazy');
}

document.addEventListener("DOMContentLoaded", function() {
  "use strict";
  yall({
    observeChanges: true
  });
});
jQuery(function() {
  "use strict";
  var
    $ = jQuery.noConflict(),
    html_tag = $(document.documentElement),
    body_tag = $(document.getElementsByTagName('body')),

    footer_id = $(document.getElementById('footer')),
    top_id = $(document.getElementById('top')),
    product_reviews = $(document.getElementById('shopify-product-reviews')),

    accordion_a = $(document.getElementsByClassName('accordion-a')),
    check_color = $(document.getElementsByClassName('check-color')),
    form_cart = $(document.getElementsByClassName('form-cart')),
    form_comment = $(document.getElementsByClassName('form-comment')),
    form_filter = $(document.getElementsByClassName('form-filter')),
    form_inline = $(document.getElementsByClassName('form-inline')),
    form_newsletter = $(document.getElementsByClassName('form-newsletter')),
    form_product = $(document.getElementsByClassName('form-product')),
    form_welcome = $(document.getElementsByClassName('form-welcome')),
    heading_rating = $(document.getElementsByClassName('heading-rating')),
    heading_wide = $(document.getElementsByClassName('heading-wide')),
    input_tag = $(':input'),
    input_inline = $(document.getElementsByClassName('input-inline')),
    list_big = $(document.getElementsByClassName('list-big')),
    list_comments = $(document.getElementsByClassName('list-comments')),
    list_collection = $(document.getElementsByClassName('list-collection')),
    list_news = $(document.getElementsByClassName('list-news')),
    list_product = $(document.getElementsByClassName('list-product')),
    list_slider = $(document.getElementsByClassName('list-slider')),
    module_featured = $(document.getElementsByClassName('module-featured')),
    module_product = $(document.getElementsByClassName('module-product')),
    page_content_section = $(document.getElementsByClassName('page-content-section')),
    nav_pagination = $(document.getElementsByClassName('nav-pagination')),
    load_more_button = $(document.getElementsByClassName('load-more-button')),
    time_element = $(document.getElementsByTagName('time')),
    singleStar = function() {
      return $('<span class="star"><span class="empty"></span><span class="fill"></span></span>');
    },
    tabs_class = $('[class*="tabs"]:not(.tabs-inner, .tabs-header)'),
    ui_slider_a = $(document.getElementsByClassName('ui-slider-a')),
    loadRes = function(u, c, i) {
      if (html_tag.is('.' + i)) {
        c();
        return true;
      }
      var s = document.createElement('script');
      s.src = u;
      s.async = true;
      s.onload = c;
      document.body.appendChild(s);
      html_tag.not('.' + i).addClass(i);
      return true;
    },
    Default = {
      utils: {
        forms: function() {
          body_tag.on('input', function (event) {
            input_inline = $(document.getElementsByClassName('input-inline'));
            form_newsletter = $(document.getElementsByClassName('form-newsletter'));
            form_inline = $(document.getElementsByClassName('form-inline'));
            form_welcome = $(document.getElementsByClassName('form-welcome'));
            heading_wide = $(document.getElementsByClassName('heading-wide'));
            if (input_inline.length || form_newsletter.length || form_inline.length || form_welcome.length || heading_wide.filter('form').length) {
              input_inline.add(form_newsletter).add(heading_wide.filter('form')).add(form_inline).add(form_welcome).add(top_id.children('form')).find('label:not(.hidden) + :input:not(select, :button)').each(function() {
                $(this).attr('placeholder', $(this).siblings('label').text()).siblings('label').addClass('hidden').attr('aria-hidden', true);
              });
            }
          });
          body_tag.trigger('input');
          body_tag.on('form-comment', function (event) {
            form_comment = $(document.getElementsByClassName('form-comment'));
            if (form_comment.length) {
              form_comment.find('label:not(.hidden) + :input:not(select, :button)').each(function() {
                $(this).attr('placeholder', $(this).siblings('label').text()).siblings('label').attr('aria-hidden', true);
              });
            }
            if (form_comment.length) {
              form_comment.find('[required]').siblings('label').append('<span class="overlay-c">*</span>');
            }
          });
          body_tag.trigger('form-comment');
          body_tag.on('semantic-number', function (event) {
            input_tag = $(':input')
            if (input_tag.filter('[type="number"]').length) {
              input_tag.filter('[type="number"]').semanticNumber();
            }
          });
          body_tag.trigger('semantic-number');
          if (form_filter.length) {
            form_filter.wrapInner('<div class="inner"></div>').append('<a href="./" class="close">Close</a>').children('.inner').children(':header:not(:first-child)').add(form_filter.find('.desktop-hide :header')).addClass('header').each(function() {
              if ($(this).is(':not(.toggle)')) {
                $(this).next().addClass('hidden');
              }
            }).append('<a href="./"></a>').children('a').on('click', function() {
              $(this).closest(':header').toggleClass('toggle mobile-toggle').next().toggleClass('hidden');
              return false;
            });
            form_filter.find('.inner .submit').each(function() {
              $(this).insertAfter($(this).closest('.inner'));
            });
            form_filter.children('a.close').on('click', function() {
              html_tag.removeClass('filter-active');
              return false;
            }).closest('#content').addClass('has-filter');
          }
          if (ui_slider_a.length) {
            ui_slider_a.each(function() {
              $(this).prepend('<p class="legend"><span>€ ' + $(this).find('input:first').val().replace('.', ',') + '</span> - <span>€ ' + $(this).find('input:last').val().replace('.', ',') + '</span></p>');
              $(this).append('<div class="slider"></div>').children('.slider').slider({
                range: true,
                min: +$(this).closest('.ui-slider-a').find('input:first').attr('min'),
                max: +$(this).closest('.ui-slider-a').find('input:last').attr('max'),
                step: 0.01,
                values: [$(this).closest('.ui-slider-a').find('input:first').val(), $(this).closest('.ui-slider-a').find('input:last').val()],
                slide: function(event, ui) {
                  $(this).closest('.ui-slider-a').find('input:first').val(ui.values[0]);
                  $(this).closest('.ui-slider-a').find('input:last').val(ui.values[1]);
                  $(this).closest('.ui-slider-a').find('.legend span:first').text('€ ' + ui.values[0]);
                  $(this).closest('.ui-slider-a').find('.legend span:last').text('€ ' + ui.values[1]);
                },
                stop: function() {
                  $(this).closest('form').submit();
                  html_tag.addClass('loading');
                }
              });
            });
          }
        },
        date: function() {
          if (footer_id.find('.date').length) {
            footer_id.find('.date').text((new Date()).getFullYear());
          }
        },
        top: function() {
          body_tag.on('top-function', function (event) {
            top_id = $(document.getElementById('top'));
            if (top_id.hasClass('v1')) {
              footer_id.after('<nav id="bottom"><ul>' + top_id.filter('.v1').find('#nav').children('ul:first-child').next('ul').html() + '</ul></nav>');
              html_tag.addClass('has-bottom');
            }
            else {
              $('#bottom').remove();
              html_tag.removeClass('has-bottom');
            }
            // if (top_id.filter(':not(.v2)').find('.list-usp:not(.mobile-hide)').length) {
            //   top_id.find('.list-usp:not(.mobile-hide)').each(function() {
            //     if ($(this).children().length > 1) {
            //       $(this).addClass('desktop-only').clone().removeClass('desktop-only').addClass('desktop-hide').insertAfter($(this));
            //       $(this).next('.desktop-hide').owlLayout().children('.inner').owlCarousel({
            //         loop: true,
            //         nav: false,
            //         dots: false,
            //         autoplay: true,
            //         autoplayTimeout: 3000,
            //         autoHeight: true,
            //         lazyLoad: true,
            //         margin: 0,
            //         items: 1,
            //         onInitialized: function() {
            //           $(this.$element).owlSemantic();
            //         },
            //         onTranslated: function() {
            //           $(this.$element).owlSemantic();
            //         }
            //       });
            //     }
            //   });
            // }
          })
          body_tag.trigger('top-function');
        },
        ratings: function() {
          body_tag.on("ratings", function(event, elements) {
            $('[data-val][data-of]').wrapInner('<span class="label"></span>').prepend('<span class="rating"></span>').each(function() {
              var i = 1,
                ss,
                rateContainer = $(this),
                maxStars = $(this).attr('data-of'),
                rate = rateContainer.data('val').toString().split('.');
              while (i <= maxStars) {
                ss = singleStar();
                rateContainer.children('.rating').append(ss);
                if (i <= rate[0]) {
                  ss.children().css('width', '100%');
                } else if (+rate[1] > 0) {
                  ss.children().css('width', (rate[1] * (rate[1].length === 1 ? 10 : 1)) + '%');
                  rate[1] = 0;
                }
                i = i + 1;
              }
            });
          })
          body_tag.trigger('ratings');
        },
        mobile: function() {
          if (jQuery.browser.mobile) {
            html_tag.addClass('mobile');
          } else {
            html_tag.addClass('no-mobile');
            if (input_tag.filter('select').length) {
              // input_tag.filter('select:not(#productSelect)').semanticSelect();
              input_tag.filter('select[data-prefix]').each(function() {
                $(this).parents('.semantic-select-wrapper').find('ul li:not(.hidden) a').prepend('<span>' + $(this).attr('data-prefix') + '</span> ');
              });
            }
          }
          if (input_tag.filter('select:has([data-color])').length) {
            input_tag.filter('select:has([data-color])').addClass('has-color').closest('.semantic-select-wrapper').addClass('has-color');
          }
        },
        owl: function() {
          body_tag.on('owl-slider', function (event) {
            module_featured = $(document.getElementsByClassName('module-featured'));
            if (module_featured.length) {
              module_featured.each(function() {
                if (!$(this).hasClass('owl-with-settings')) {
                  if ($(this).children().length > 1) {
                    $(this).owlLayout().children('.inner').owlCarousel({
                      loop: true,
                      nav: false,
                      dots: true,
                      autoHeight: true,
                      lazyLoad: true,
                      margin: 0,
                      items: 1,
                      autoplay: false,
                      autoplayTimeout: 5000,
                      autoplayHoverPause: true,
                      onInitialized: function() {
                        $(this.$element).owlSemantic();
                      },
                      onTranslated: function() {
                        $(this.$element).owlSemantic();
                      }
                    });
                  }
                } else {
                  var autoplay = $(this).data("autoplay");
                  var autoplayTimeOut = $(this).data("autoplay-time");
                  if ($(this).children().length > 1) {
                    $(this).owlLayout().children('.inner').owlCarousel({
                      loop: true,
                      nav: false,
                      dots: true,
                      autoHeight: true,
                      lazyLoad: true,
                      margin: 0,
                      items: 1,
                      autoplay: autoplay,
                      autoplayTimeout: autoplayTimeOut,
                      autoplayHoverPause:true,
                      onInitialized: function (event) {
                        $(this.$element).owlSemantic();
                      },
                      onTranslated: function () {
                        $(this.$element).owlSemantic();
                      }
                    });
                  }
                }
              });
            }
          list_news = $(document.getElementsByClassName('list-news'));
          if (list_news.filter('.slider').length) {
            list_news.filter('.slider').each(function() {
              if ($(this).children().length > 1) {
                $(this).owlLayout().children('.inner').owlCarousel({
                  loop: false,
                  nav: true,
                  dots: true,
                  autoHeight: true,
                  lazyLoad: true,
                  margin: 25,
                  items: 1,
                  onInitialized: function() {
                    $(this.$element).owlSemantic();
                  },
                  onTranslated: function() {
                    $(this.$element).owlSemantic();
                  },
                  responsive: {
                    760: {
                      autoWidth: true
                    }
                  }
                });
              }
            });
          }
        })
        body_tag.trigger('owl-slider');
          if (list_collection.find('figure:has(img + img)').length) {
            list_collection.find('figure:has(img + img)').each(function() {
              if ($(this).children().length > 1) {
                $(this).owlLayout().children('.inner').owlCarousel({
                  loop: true,
                  nav: false,
                  dots: true,
                  autoHeight: true,
                  lazyLoad: true,
                  margin: 0,
                  items: 1,
                  onInitialized: function() {
                    $(this.$element).owlSemantic();
                  },
                  onTranslated: function() {
                    $(this.$element).owlSemantic();
                  }
                });
              }
            });
          }
          if ($('link[href*="ola"]').length) {
            if (list_collection.filter('.slider').length) {
              list_collection.filter('.slider').each(function() {
                if ($(this).children().length > 1) {
                  $(this).owlLayout().children('.inner').owlCarousel({
                    loop: true,
                    nav: true,
                    dots: true,
                    autoHeight: true,
                    lazyLoad: true,
                    margin: 0,
                    onInitialized: function() {
                      $(this.$element).owlSemantic();
                    },
                    onTranslated: function() {
                      $(this.$element).owlSemantic();
                    },
                    responsive: {
                      0: {
                        autoWidth: true,
                        margin: 0
                      },
                      760: {
                        items: 3,
                        autoWidth: false
                      },
                      1000: {
                        items: 4,
                        margin: 0
                      }
                    }
                  });
                }
              });
            }
          } else {
            body_tag.on('list-collection-slider', function (event) {
              list_collection = $(document.getElementsByClassName('list-collection'));
              if (list_collection.filter('.slider:not(.cart-recommended)').length) {
                list_collection.filter('.slider:not(.cart-recommended)').each(function() {
                  if ($(this).children().length > 1) {
                    $(this).owlLayout().children('.inner').owlCarousel({
                      loop: false,
                      nav: true,
                      dots: true,
                      autoHeight: true,
                      lazyLoad: true,
                      margin: 15,
                      responsiveRefreshRate: 0,
                      onInitialized: function() {
                        $(this.$element).owlSemantic();
                        $('.slider.product-recommended').css("display","block");
                      },
                      onTranslated: function() {
                        $(this.$element).owlSemantic();
                      },
                      responsive: {
                        0: {
                          autoWidth: true,
                          margin: 15
                        },
                        760: {
                          items: 3,
                          autoWidth: false
                        },
                        1000: {
                          items: 4,
                          margin: 25
                        }
                      }
                    });

                  }
                });
              }
            });
          body_tag.trigger('list-collection-slider');
          }
          body_tag.on('product-page-slider', function (event) {
            list_product = $(document.getElementsByClassName('list-product'));
            if (list_product.length) {
              list_product.each(function() {
                if ($(this).children().length > 1) {
                  $(this).addClass('mobile-hide').clone().removeClass('mobile-hide').addClass('mobile-only').insertAfter($(this));
                  $(this).next('.mobile-only').each(function() {
                    $(this).find('[data-fancybox-group]').each(function() {
                      $(this).attr('data-fancybox-group', $(this).attr('data-fancybox-group') + '2');
                    });
                    $(this).owlLayout().children('.inner').owlCarousel({
                      loop: false,
                      nav: false,
                      dots: true,
                      autoHeight: true,
                      lazyLoad: true,
                      margin: 0,
                      items: 1,
                      onInitialized: function() {
                        $(this.$element).owlSemantic();
                      },
                      onTranslated: function() {
                        $(this.$element).owlSemantic();
                      }
                    });
                    $(this).find('ul.label').appendTo($(this));
                  });
                }
              });
            }
          });
          body_tag.trigger('product-page-slider');
          if (list_slider.length) {
            list_slider.each(function() {
              $(this).addClass('items-' + $(this).children('li').length);
              if ($(this).children().length > 1) {
                $(this).addClass('is-slider').wrapInner('<div class="inner owl-carousel"></div>').children('.inner').children().wrap('<div class="item"></div>');
                $(this).append('<ul class="pager custom"></ul>').children('.inner').children().each(function(i) {
                  $(this).find('img:first').clone().wrap('<a href="./" role="button" data-slide-index="' + i + '"></a>').parent().appendTo($(this).parents('.is-slider:first').find('.pager.custom'));
                });
                $(this).children('.inner').owlCarousel({
                  nav: false,
                  dots: false,
                  autoHeight: true,
                  loop: false,
                  items: 1,
                  margin: 0,
                  onInitialized: function() {
                    $(this.$element).owlSemantic();
                  },
                  onTranslated: function(event) {
                    $(this.$element).owlSemantic();
                    $(this.$element).parents('.is-slider:first').find('[data-slide-index]').removeClass('current').parent().children('[data-slide-index="' + event.item.index + '"]').addClass('current');
                  }
                });
                $(this).find('a[data-slide-index]').wrap('<li></li>').each(function() {
                  if ($(this).parent().is(':first-child')) {
                    $(this).addClass('current').attr('aria-pressed', true);
                  } else {
                    $(this).attr('aria-pressed', false);
                  }
                }).on('click', function() {
                  var n = $(this),
                    f = n.parents('.is-slider:first');
                  f.find('.pager a[data-slide-index]').each(function(k, v) {
                    if ((v = $(v)).is('[data-slide-index="' + n.attr('data-slide-index') + '"]')) {
                      v.attr('aria-pressed', true).addClass('current');
                    } else {
                      v.attr('aria-pressed', false).removeClass('current');
                    }
                  });
                  f.find('.owl-carousel:first').trigger('to.owl.carousel', n.attr('data-slide-index'));
                  return false;
                });
              }
              $(this).find('ul.label').appendTo($(this));
            });
          }
        },
        cookie: function() {
            footer_id.after('<a class="totop" href="#root">Scroll to top</a>');
        },
        done: function() {
          var tag = document.createElement('script');
          tag.src = "//cdn.shopify.com/s/files/1/0277/5230/0681/t/2/assets/async-scripts.js?v=95830710663977928401576601833";
          document.body.appendChild(tag);
        },
        popups: function() {
          var loadPopup = function(id) {
              loadRes('//cdn.shopify.com/s/files/1/0277/5230/0681/t/2/assets/popup.js?v=80733759960060195871576582850', function() {
                if ($.fn.semanticPopup !== undefined) {
                  var cde = $(document.querySelectorAll('[class^="popup-"]:not(html)'));
                  if (cde && !html_tag.is('.spi')) {
                    cde.semanticPopup();
                  }
                  $.openPopup(id);
                }
              }, 'popup-loaded');
            },
            dt = decodeURIComponent(document.location.hash.substring(1));
          $('a[data-popup]').on('click', function() {
            loadPopup($(this).attr('data-popup'));
            if ($(this).is('[data-popup="search"]')) {
              $('[data-title="search]').find('input').focus();
            }
            return false;
          });
          if (document.location.hash.length) {
            if (dt) {
              loadPopup(dt);
            }
          }
        },
        miscellaneous: function() {
          if (list_news.find('li:has(figure a)').length) {
            list_news.find('li:has(figure a)').each(function() {
              $(this).find('a:first').attr({
                'tabindex': -1,
                'aria-hidden': true,
                'focusable': false
              }).clone().removeAttr('tabindex aria-hidden focusable').addClass('clone').prependTo($(this));
              $(this).find('a.clone').prev().addClass('last-child').closest('li').find('a.clone').children().remove();
            });
          }
          body_tag.on('accordion', function (event) {
            accordion_a = $(document.getElementsByClassName('accordion-a'));
            if (accordion_a.length) {
              accordion_a.semanticAccordion().each(function() {
                if ($(this).is('.accordion-b')) {
                  $(this).find('.header').addClass('toggle').next('div').show();
                }
              });
            }
          });
          body_tag.trigger('accordion');
          if (list_collection.length) {
            list_collection.each(function() {
              $(this).find('form :input').on('change', function() {
                $(this).closest('form').addClass('chosen');
              });
              $(this).find('li.wide').each(function() {
                $(this).clone().addClass('three').insertBefore($(this).prev());
              });
              $(this).find('li:has(.label)').addClass('has-label');
              $(this).find('li.has-label:has(li.btn:only-child)').removeClass('has-label');
            });
            $(window).on('load', function() {
              list_collection.find('li + li.empty').each(function() {
                $(this).css('height', $(this).prev().find('figure').outerHeight());
              });
            });
            $(window).on('resize', function() {
              list_collection.find('li + li.empty').each(function() {
                $(this).css('height', $(this).prev().find('figure').outerHeight());
              });

            });
          }
          if (check_color.length) {
            check_color.find('[data-color]').each(function() {
              $(this).find('label').append('<span class="color" style="background:' + $(this).attr('data-color') + '";"></span>');
            });
          }
          body_tag.on('put-in-tabs', function () {
            tabs_class = $('[class*="tabs"]:not(.tabs-inner, .tabs-header)');
            if (tabs_class.length) {
              tabs_class.semanticTabs();
              tabs_class.filter('.toggle-this').find('.tabs-header:first').addClass('toggle').next('.tabs-inner').addClass('toggle');
              tabs_class.filter('.toggle-this').find('.heading-rating:first').addClass('toggle');
              tabs_class.filter('.tabs-b').find('.tabs-header:first').addClass('toggle').next('.tabs-inner').addClass('toggle');
            }
          })
          body_tag.trigger('put-in-tabs');
          // if (module_product.length) {
          //   module_product.filter(':not(.a)').each(function() {
          //     $(this).find('header:first').addClass('mobile-hide module-product-header').clone().removeClass('mobile-hide').addClass('mobile-only').insertBefore($(this));
          //   });
          // }
          if (list_comments.filter('.a').length) {
            list_comments.filter('.a').find('p').each(function() {
              if ($(this).outerHeight() > 75) {
                $(this).addClass('clip');
              }
              $(this).after('<a class="toggle" href="./">Read more</a>').next('a.toggle').on('click', function() {
                $(this).prev('.clip').removeClass('clip').next('a.toggle').remove();
                return false;
              });
            });
          }
          body_tag.on('heading-rating', function () {
            heading_rating = $(document.getElementsByClassName('heading-rating'));
            if (heading_rating.length) {
              heading_rating.each(function() {
                $(this).find(':header').addClass('header').append('<a class="toggle" href="./"></a>').children('a.toggle').on('click', function() {
                  $(this).parents('.heading-rating').toggleClass('toggle');
                  return false;
                });
              });
            }
          });
          body_tag.trigger('heading-rating');
          if (form_product.find('.fieldset:has(.check-color)').length) {
            form_product.find('.fieldset:has(.check-color)').addClass('has-colors');
          }
          if (list_big.filter('.cols').length) {
            list_big.filter('.cols').each(function() {
              var $grid = $(this).isotope({masonry: {
                columnWidth: 1
              }});
            });
          }
          if (product_reviews.length) {
            product_reviews.hide();
            setTimeout(function() {
              product_reviews.show();
              var rating = product_reviews.find('meta[itemprop="ratingValue"]').attr('content');
              var stars = product_reviews.find('.spr-summary-starrating');
              stars.append("<span class='custom-rating'>" + rating + "</span> / 5");

              var headerHeading = product_reviews.find('.spr-header');
              headerHeading.addClass('heading-rating');
              var header = product_reviews.find('.spr-header-title');
              header.addClass('header').append('<a class="toggle" href="./"></a>').children('a.toggle').on('click', function() {
                $(this).parents('.heading-rating').toggleClass('toggle');
                return false;
              });
            }, 2000);
          }
          if (page_content_section.length) {
            page_content_section.wrapInner('<p></p>');
          }
          body_tag.on('pagination', function (event) {
            nav_pagination = $(document.getElementsByClassName('nav-pagination'));
            if (nav_pagination.length) {
              nav_pagination.wrapInner('<ol class="pagination"></ol>');
              nav_pagination.find('.page.current').each(function() {
                $(this).replaceWith('<li class="active"><a>' + $(this).html() + '</a></li>');
              })
              nav_pagination.find('.prev').each(function() {
                $(this).replaceWith('<li class="prev">' + $(this).html() + '</li>');
              })
              nav_pagination.find('.next').each(function() {
                $(this).replaceWith('<li class="next">' + $(this).html() + '</li>');
              })
              nav_pagination.find('span').each(function() {
                $(this).replaceWith('<li>' + $(this).html() + '</li>');
              })
            }
          });
          body_tag.trigger('pagination');
          if (load_more_button.length) {
            load_more_button.on('click', function() {
              var url = $(this).attr("data-href");
              if (url != "") {
                $.ajax({
                  url: url,
                  type: 'GET',
                })
                .success(function(data) {
                  var newPageContent = $(data).find('.list-featured').html();
                  if (!newPageContent) {
                    newPageContent = $(data).find('.list-collection').html();
                  }
                  newPageContent = newPageContent.replace(/(?:(?:\r\n|\r|\n)\s*){2}/gm, "");
                  if (newPageContent != "") {
                    if ($('.list-featured').length) {
                      var section = $('.list-featured')
                      section.append(newPageContent);
                    } else if ($('.list-collection').length) {
                      var section = $('.list-collection')
                      section.append(newPageContent);
                    }
                    body_tag.trigger('lazyload-again', [section]);
                    var nextPage = parseInt(url.substr(url.length - 1)) + 1;
                    var maxPages = parseInt(load_more_button.attr("data-pages"));
                    if (nextPage <= maxPages) {
                      var nextUrl = url.replace(/.$/,nextPage);
                      load_more_button.attr("data-href", nextUrl);
                    }
                    else {
                      load_more_button.hide();
                    }
                  }
                });
              }
            });
          }
          if (time_element.length) {
            time_element.each(function () {
              $(this).replaceWith($(this).text());
            })
          }
          body_tag.on('lazyload-again', function (event, element) {
            // used in shopify theme editor fixes
            element.find('img').each(function() {
              if ($(this).attr('data-src')) {
                $(this).attr('src', $(this).attr('data-src'));
              }
            })
            element.find('.lazy-bg').addClass('lazy-bg-loaded').removeClass('lazy-bg');
          })
          body_tag.on('append-stars', function (event) {
            if (jQuery('.trustmark').length) {
              var stars = jQuery(".rating-a.c .rating .star");
              if (stars.length) {
      				  var filledStars = jQuery(".rating-a.c .rating .fill");
      	        var filledStarSVG = document.getElementById("star-filled");
      	        var filledStarEncodedData = encodeURIComponent(filledStarSVG.innerHTML);
      	        filledStars.css('background-image', 'url("data:image/svg+xml,'+filledStarEncodedData+'")');

                var emptyStars = jQuery(".rating-a.c .rating .empty");
                var emptyStarSVG = document.getElementById("star-empty");
      	        var emptyStarEncodedData = encodeURIComponent(emptyStarSVG.innerHTML);
      	        emptyStars.css('background-image', 'url("data:image/svg+xml,'+emptyStarEncodedData+'")');
      	      }
      	      else {
      	        setTimeout(function() {
      	          body_tag.trigger('append-stars');
      	        }, 15);
      	      }
      			}
          })
          body_tag.trigger('append-stars');
          body_tag.on('show-recently-viewed', function (event) {
            var el = $('#recently-viewed-products');
            var recent_max_qty = el.data("recent_max_qty");
            var show_vendor = el.data("show_vendor");
            var button_text = el.data("button_text");
            Shopify.Products.showRecentlyViewed( { howManyToShow: recent_max_qty, showVendor: show_vendor, buttonText: button_text } );
          });
          if ($('.recently-viewed-enabled').length) {
            body_tag.trigger('show-recently-viewed');
          }
        }
      }
    };

  setTimeout(function() {
    Default.utils.date();
    Default.utils.forms();
    Default.utils.miscellaneous();
    Default.utils.top();
    Default.utils.popups();
    Default.utils.owl();
    Default.utils.cookie();
    Default.utils.mobile();
    Default.utils.ratings();
    Default.utils.done();
  }, 0);

});

/*!*/

jQuery(function($) {
  /* CUSTOM JS */

  /* ------------- LIVESEARCH ------------- */

  function liveSearch(cur) {
    var form = cur.closest('form');
    var type = form.data('search-type');
    var autocomplete = $('.search-autocomplete[data-search-type="' + type + '"]');
    var input = $('[data-input=' + type + ']');
    var query = cur.val();
    if (query.length > 1) {
      $('#top > form > .search-autocomplete').parents('form').addClass('full').find('a.remove').removeAttr('tabindex');
      jQuery.getJSON("/search/suggest.json", {
        s: query,
        resources: {
          "types": ["product"],
          "limit": 3,
          "unavailable_products": "bury"
        }
      }).done(function(response) {
        var productSuggestions = response.resources.results.products;
        if (productSuggestions.length > 0) {
          var productsHtml = [];
          $.each(productSuggestions, function(index, product) {
            var productHtml = '';
            productHtml += '<li>';
            productHtml += '<a href="' + product.url + '">';
            productHtml += '<span class="img">';
            if (product.image != null) {
              productHtml += '<img src="' + product.image + '" alt="' + product.title + '" width="60" height="60">';
            } else {
              productHtml += '<svg class="placeholder-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M375.5 345.2c0-.1 0-.1 0 0 0-.1 0-.1 0 0-1.1-2.9-2.3-5.5-3.4-7.8-1.4-4.7-2.4-13.8-.5-19.8 3.4-10.6 3.6-40.6 1.2-54.5-2.3-14-12.3-29.8-18.5-36.9-5.3-6.2-12.8-14.9-15.4-17.9 8.6-5.6 13.3-13.3 14-23 0-.3 0-.6.1-.8.4-4.1-.6-9.9-3.9-13.5-2.1-2.3-4.8-3.5-8-3.5h-54.9c-.8-7.1-3-13-5.2-17.5-6.8-13.9-12.5-16.5-21.2-16.5h-.7c-8.7 0-14.4 2.5-21.2 16.5-2.2 4.5-4.4 10.4-5.2 17.5h-48.5c-3.2 0-5.9 1.2-8 3.5-3.2 3.6-4.3 9.3-3.9 13.5 0 .2 0 .5.1.8.7 9.8 5.4 17.4 14 23-2.6 3.1-10.1 11.7-15.4 17.9-6.1 7.2-16.1 22.9-18.5 36.9-2.2 13.3-1.2 47.4 1 54.9 1.1 3.8 1.4 14.5-.2 19.4-1.2 2.4-2.3 5-3.4 7.9-4.4 11.6-6.2 26.3-5 32.6 1.8 9.9 16.5 14.4 29.4 14.4h176.8c12.9 0 27.6-4.5 29.4-14.4 1.2-6.5-.5-21.1-5-32.7zm-97.7-178c.3-3.2.8-10.6-.2-18 2.4 4.3 5 10.5 5.9 18h-5.7zm-36.3-17.9c-1 7.4-.5 14.8-.2 18h-5.7c.9-7.5 3.5-13.7 5.9-18zm4.5-6.9c0-.1.1-.2.1-.4 4.4-5.3 8.4-5.8 13.1-5.8h.7c4.7 0 8.7.6 13.1 5.8 0 .1 0 .2.1.4 3.2 8.9 2.2 21.2 1.8 25h-30.7c-.4-3.8-1.3-16.1 1.8-25zm-70.7 42.5c0-.3 0-.6-.1-.9-.3-3.4.5-8.4 3.1-11.3 1-1.1 2.1-1.7 3.4-2.1l-.6.6c-2.8 3.1-3.7 8.1-3.3 11.6 0 .2 0 .5.1.8.3 3.5.9 11.7 10.6 18.8.3.2.8.2 1-.2.2-.3.2-.8-.2-1-9.2-6.7-9.8-14.4-10-17.7 0-.3 0-.6-.1-.8-.3-3.2.5-7.7 3-10.5.8-.8 1.7-1.5 2.6-1.9h155.7c1 .4 1.9 1.1 2.6 1.9 2.5 2.8 3.3 7.3 3 10.5 0 .2 0 .5-.1.8-.3 3.6-1 13.1-13.8 20.1-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .3-.1 13.5-7.5 14.3-17.5 14.6-21.3 0-.3 0-.5.1-.8.4-3.5-.5-8.5-3.3-11.6l-.6-.6c1.3.4 2.5 1.1 3.4 2.1 2.6 2.9 3.5 7.9 3.1 11.3 0 .3 0 .6-.1.9-1.5 20.9-23.6 31.4-65.5 31.4h-43.8c-41.8 0-63.9-10.5-65.4-31.4zm91 89.1h-7c0-1.5 0-3-.1-4.2-.2-12.5-2.2-31.1-2.7-35.1h3.6c.8 0 1.4-.6 1.4-1.4v-14.1h2.4v14.1c0 .8.6 1.4 1.4 1.4h3.7c-.4 3.9-2.4 22.6-2.7 35.1v4.2zm65.3 11.9h-16.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h16.8v2.8h-62.2c0-.9-.1-1.9-.1-2.8h33.9c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-33.9c-.1-3.2-.1-6.3-.1-9h62.5v9zm-12.5 24.4h-6.3l.2-1.6h5.9l.2 1.6zm-5.8-4.5l1.6-12.3h2l1.6 12.3h-5.2zm-57-19.9h-62.4v-9h62.5c0 2.7 0 5.8-.1 9zm-62.4 1.4h62.4c0 .9-.1 1.8-.1 2.8H194v-2.8zm65.2 0h7.3c0 .9.1 1.8.1 2.8H259c.1-.9.1-1.8.1-2.8zm7.2-1.4h-7.2c.1-3.2.1-6.3.1-9h7c0 2.7 0 5.8.1 9zm-7.7-66.7v6.8h-9v-6.8h9zm-8.9 8.3h9v.7h-9v-.7zm0 2.1h9v2.3h-9v-2.3zm26-1.4h-9v-.7h9v.7zm-9 3.7v-2.3h9v2.3h-9zm9-5.9h-9v-6.8h9v6.8zm-119.3 91.1c-2.1-7.1-3-40.9-.9-53.6 2.2-13.5 11.9-28.6 17.8-35.6 5.6-6.5 13.5-15.7 15.7-18.3 11.4 6.4 28.7 9.6 51.8 9.6h6v14.1c0 .8.6 1.4 1.4 1.4h5.4c.3 3.1 2.4 22.4 2.7 35.1 0 1.2.1 2.6.1 4.2h-63.9c-.8 0-1.4.6-1.4 1.4v16.1c0 .8.6 1.4 1.4 1.4H256c-.8 11.8-2.8 24.7-8 33.3-2.6 4.4-4.9 8.5-6.9 12.2-.4.7-.1 1.6.6 1.9.2.1.4.2.6.2.5 0 1-.3 1.3-.8 1.9-3.7 4.2-7.7 6.8-12.1 5.4-9.1 7.6-22.5 8.4-34.7h7.8c.7 11.2 2.6 23.5 7.1 32.4.2.5.8.8 1.3.8.2 0 .4 0 .6-.2.7-.4 1-1.2.6-1.9-4.3-8.5-6.1-20.3-6.8-31.1H312l-2.4 18.6c-.1.4.1.8.3 1.1.3.3.7.5 1.1.5h9.6c.4 0 .8-.2 1.1-.5.3-.3.4-.7.3-1.1l-2.4-18.6H333c.8 0 1.4-.6 1.4-1.4v-16.1c0-.8-.6-1.4-1.4-1.4h-63.9c0-1.5 0-2.9.1-4.2.2-12.7 2.3-32 2.7-35.1h5.2c.8 0 1.4-.6 1.4-1.4v-14.1h6.2c23.1 0 40.4-3.2 51.8-9.6 2.3 2.6 10.1 11.8 15.7 18.3 5.9 6.9 15.6 22.1 17.8 35.6 2.2 13.4 2 43.2-1.1 53.1-1.2 3.9-1.4 8.7-1 13-1.7-2.8-2.9-4.4-3-4.6-.2-.3-.6-.5-.9-.6h-.5c-.2 0-.4.1-.5.2-.6.5-.8 1.4-.3 2 0 0 .2.3.5.8 1.4 2.1 5.6 8.4 8.9 16.7h-42.9v-43.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v44.9c0 .1-.1.2-.1.3 0 .1 0 .2.1.3v9c-1.1 2-3.9 3.7-10.5 3.7h-7.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h7.5c5 0 8.5-.9 10.5-2.8-.1 3.1-1.5 6.5-10.5 6.5H210.4c-9 0-10.5-3.4-10.5-6.5 2 1.9 5.5 2.8 10.5 2.8h67.4c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-67.4c-6.7 0-9.4-1.7-10.5-3.7v-54.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v43.8h-43.6c4.2-10.2 9.4-17.4 9.5-17.5.5-.6.3-1.5-.3-2s-1.5-.3-2 .3c-.1.2-1.4 2-3.2 5 .1-4.9-.4-10.2-1.1-12.8zm221.4 60.2c-1.5 8.3-14.9 12-26.6 12H174.4c-11.8 0-25.1-3.8-26.6-12-1-5.7.6-19.3 4.6-30.2H197v9.8c0 6.4 4.5 9.7 13.4 9.7h105.4c8.9 0 13.4-3.3 13.4-9.7v-9.8h44c4 10.9 5.6 24.5 4.6 30.2z"></path><path d="M286.1 359.3c0 .4.3.7.7.7h14.7c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-14.7c-.3 0-.7.3-.7.7zm5.3-145.6c13.5-.5 24.7-2.3 33.5-5.3.4-.1.6-.5.4-.9-.1-.4-.5-.6-.9-.4-8.6 3-19.7 4.7-33 5.2-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm-11.3.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H242c-19.9 0-35.3-2.5-45.9-7.4-.4-.2-.8 0-.9.3-.2.4 0 .8.3.9 10.8 5 26.4 7.5 46.5 7.5h38.1zm-7.2 116.9c.4.1.9.1 1.4.1 1.7 0 3.4-.7 4.7-1.9 1.4-1.4 1.9-3.2 1.5-5-.2-.8-.9-1.2-1.7-1.1-.8.2-1.2.9-1.1 1.7.3 1.2-.4 2-.7 2.4-.9.9-2.2 1.3-3.4 1-.8-.2-1.5.3-1.7 1.1s.2 1.5 1 1.7z"></path><path d="M275.5 331.6c-.8 0-1.4.6-1.5 1.4 0 .8.6 1.4 1.4 1.5h.3c3.6 0 7-2.8 7.7-6.3.2-.8-.4-1.5-1.1-1.7-.8-.2-1.5.4-1.7 1.1-.4 2.3-2.8 4.2-5.1 4zm5.4 1.6c-.6.5-.6 1.4-.1 2 1.1 1.3 2.5 2.2 4.2 2.8.2.1.3.1.5.1.6 0 1.1-.3 1.3-.9.3-.7-.1-1.6-.8-1.8-1.2-.5-2.2-1.2-3-2.1-.6-.6-1.5-.6-2.1-.1zm-38.2 12.7c.5 0 .9 0 1.4-.1.8-.2 1.3-.9 1.1-1.7-.2-.8-.9-1.3-1.7-1.1-1.2.3-2.5-.1-3.4-1-.4-.4-1-1.2-.8-2.4.2-.8-.3-1.5-1.1-1.7-.8-.2-1.5.3-1.7 1.1-.4 1.8.1 3.7 1.5 5 1.2 1.2 2.9 1.9 4.7 1.9z"></path><path d="M241.2 349.6h.3c.8 0 1.4-.7 1.4-1.5s-.7-1.4-1.5-1.4c-2.3.1-4.6-1.7-5.1-4-.2-.8-.9-1.3-1.7-1.1-.8.2-1.3.9-1.1 1.7.7 3.5 4.1 6.3 7.7 6.3zm-9.7 3.6c.2 0 .3 0 .5-.1 1.6-.6 3-1.6 4.2-2.8.5-.6.5-1.5-.1-2s-1.5-.5-2 .1c-.8.9-1.8 1.6-3 2.1-.7.3-1.1 1.1-.8 1.8 0 .6.6.9 1.2.9z"></path></svg>';
            }
            productHtml += '</span>';
            productHtml += product.title;
            productHtml += '<span class="price">€' + product.price + '</span>';
            productHtml += '</a>';
            productHtml += '</li>';
            productsHtml.push(productHtml);
          });
          productsHtml = productsHtml.join('');
          autocomplete.find('.list-cart.small').empty();
          autocomplete.find('.list-cart.small').html(productsHtml);
          autocomplete.find('.list-cart.small').append('<li class="btn"><a href="/search?q=' + query + '">View all results</a></li>');
        } else {
          autocomplete.find('.list-cart.small').empty();
          autocomplete.find('.list-cart.small').append('<li class="">No products found</li>');
        }
      });
    }
  }
  if ($('.search-autocomplete').length > 0) {
    $('#formSearch input').keyup(function() {
      liveSearch($(this));
    });
  }
  /* ------------- END LIVESEARCH ------------- */

  /* ------------- BEGIN COLLECTION SORT ORDER ------------- */
  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }
  $('#sortselect')
    // select the current sort order
    .val('')
    .bind('change', function() {
      Shopify.queryParams.sort_by = $(this).val();
      location.search = $.param(Shopify.queryParams).replace(/\+/g, '%20');
    });
  /* ------------- END COLLECTION SORT ORDER ------------- */

  /* ------------- BEGIN DELIVERY TIMER ------------- */
  function deliveryTimer() {
    var el = $('#mycountdown');
    var showDays = el.data('days');
    var freeShippingFrom = el.data('before-time');
    var showFrom = el.data('show-from');
    var startTimer = false;

    if (showDays) {
      for (var i = 0; i < showDays.length; i++) {
        var name = showDays[parseInt(i)];
        if (name == new Date().getDay()) {
          startTimer = true;
        }
      }
    }

    if (startTimer) {

      var showFromDate = [showFrom, 00, 00];

      var fromDate = new Date();
      fromDate.setHours(showFromDate[0]);
      fromDate.setMinutes(showFromDate[1]);
      fromDate.setSeconds(showFromDate[2]);

      var nowDate = new Date();

      if (nowDate > fromDate) {

        var myreset = [freeShippingFrom, 00, 00];

        var mycountdown = startCountdown();

        function startCountdown() {
          var enddate = calculateEndDate();
          return setInterval(function() {
            tickTock(calculateStartDate(), enddate)
          }, 1000);
        }

        function calculateStartDate() {
          return new Date();
        }

        function calculateEndDate() {
          var enddate = new Date();
          enddate.setHours(myreset[0]);
          enddate.setMinutes(myreset[1]);
          enddate.setSeconds(myreset[2]);
          return enddate;
        }

        function tickTock(startdate, enddate) {
          var diff = enddate.getTime() - startdate.getTime();
          d = diff >= 0 ? diff : diff + 24 * 3600 * 1000;
          var h = Math.floor(d / 3600 / 1000);
          var m = Math.floor(d / 60 / 1000) - 60 * h;
          var s = Math.floor(d / 1000) - 3600 * h - 60 * m;
          printCountdown(h, m, s);
        }

        function printCountdown(h, m, s) {
          var zeroSec = '';
          var zeroMin = '';
          var zeroHour = '';
          if (s.toString().length < 2) {
            zeroSec = '0';
          }
          if (m.toString().length < 2) {
            zeroMin = '0';
          }
          if (h.toString().length < 2) {
            zeroHour = '0';
          }
          var t = zeroHour + h.toString() + ':' + zeroMin + m.toString() + ':' + '<span class="overlay-g">' + zeroSec + s.toString() + '</span>';
          $('#mycountdown').html(t);
        }
        $('.countdown').removeClass('hidden');
      }
    }
  }
  deliveryTimer();
  /* ------------- END DELIVERY TIMER ------------- */

  /* ------------- BEGIN RECOMMENDATION SECTIONS ------------- */
  var recommendationsSlider = function() {
      if ($('.slider.product-recommended').children().length == 0) {
        $('.recommended-container').hide();
        $('.custom-recommended-container').hide();
      }
      if ($('.slider.product-recommended').children().length > 0 ) {
        setTimeout(function(){
          $('body').trigger('lazyload-again', [$('.section-product-recommendations')]);
          $('body').trigger('heading-rating');
        }, 0);
      }
      $('body').trigger('list-collection-slider');
  };
  var cartRecommendationsSlider = function() {
    setTimeout(function() {
    if ($('.list-collection').filter('.slider.cart-recommended').length) {
      $('.cart-recommended-container').show();
      $('body').trigger('lazyload-again', [$('.section-')]);
      $('.list-collection').filter('.slider.cart-recommended').each(function() {
          var toAdd = $('#custom-recommended').html();
          $('.slider.cart-recommended').prepend(toAdd);
          if ($('.slider.cart-recommended').children().length > 1) {
            var seen = {};
            $('.slider.cart-recommended').children().each(function() {
              // Remove products which are added multiple times
                var txt = $(this).text();
                if (seen[txt]) {
                  $(this).remove();
                } else {
                  seen[txt] = true;
                }
            });
            $('.slider.cart-recommended').owlLayout().children('.inner').owlCarousel({
              loop: false,
              nav: true,
              dots: true,
              autoHeight: true,
              lazyLoad: true,
              margin: 15,
              onInitialized: function() {
                $(this.$element).owlSemantic();
              },
              onTranslated: function() {
                $(this.$element).owlSemantic();
              },
              responsive: {
                0: {
                  autoWidth: true,
                  margin: 15
                },
                760: {
                  items: 3,
                  autoWidth: false
                },
                1000: {
                  items: 4,
                  margin: 25
                }
              }
            });
          }
        })
      }
    }, 0);
  }
  var bindToCart = function () {
    // Bind the ajax cart to the recommended products "add to cart" buttons.
    ajaxCart.init({
      formSelector: '.AddToCartForm',
      cartContainer: '#cart-inner',
      addToCartSelector: '.add-to-cart-button',
      cartCountSelector: '.header-cart-count',
      cartCostSelector: '#CartCost',
      enableQtySelectors: false,
      moneyFormat: null,
      showVendor: true
    });
  }
  var loadAll = function() {
    var productRecommendationsSection = document.querySelector(".product-product-recommendations");
    if (productRecommendationsSection === null) { return; }
    var productId = productRecommendationsSection.dataset.productId;
    var limit = productRecommendationsSection.dataset.limit;
    var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-product-recommendations").innerHTML;
        // Put the recommended products in a owl slider.
        if ($('.list-collection').filter('.slider.product-recommended').length) {
          $('.list-collection').filter('.slider.product-recommended').each(function() {
            setTimeout(function(){
              if ($('.recommended-container').data("custom") == true) {
                var toAdd = $('#custom-recommended').html();
                $('.slider.product-recommended').prepend(toAdd);
              }
              recommendationsSlider();
            }, 0);
          })
        }
        // Bind the ajax cart to the recommended products "add to cart" buttons.
        bindToCart();
      }
    };
    request.send();
  };
  var loadOnlyCustom = function() {
    var container = $('.custom-recommended-container');
    if (container === null) { return; }
    if ($('.list-collection').filter('.slider.product-recommended').length) {
      $('.list-collection').filter('.slider.product-recommended').each(function() {
        setTimeout(function(){
          var toAdd = $('#custom-recommended').html();
          $('.slider.product-recommended').prepend(toAdd);
          recommendationsSlider();
        }, 0);
      })
    }
    bindToCart();
  }
  if ($('.product-product-recommendations').length) {
    loadAll();
  }
  else if ($('.custom-recommended-container').length) {
    loadOnlyCustom();
  }

  var loadProductRecommendationsIntoSection = function() {
  var productRecommendationsSection = $(".cart-product-recommendations"),
      count = productRecommendationsSection.length;
  productRecommendationsSection.each(function () {
    var inElement = $(".cart-recommended");
    if (productRecommendationsSection === null) { return; }
    var productId = $(this).data("productId");
    var limit = $(this).data("limit");
    var requestUrl = "/recommendations/products?section_id=cart-product-recommendations&limit="+limit+"&product_id="+productId;
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        var listitems = container.querySelector(".cart-product-recommendations").innerHTML;
        inElement.append(listitems);
        if (!--count) {
          cartRecommendationsSlider(); //  Put the recommended products in a owl slider.
        }
        // Bind the ajax cart to the recommended products "add to cart" buttons.
        ajaxCart.init({
          formSelector: '.AddToCartForm',
          cartContainer: '#cart-inner',
          addToCartSelector: '.add-to-cart-button',
          cartCountSelector: '.header-cart-count',
          cartCostSelector: '#CartCost',
          enableQtySelectors: false,
          moneyFormat: null,
          showVendor: true
        });
      }
    };
    request.send();
  })
};
loadProductRecommendationsIntoSection();
  /* ------------- END RECOMMENDATION SECTIONS ------------- */

  /* ------------- BEGIN SHOPIFY THEME EDITOR FIXES ------------- */
  document.addEventListener("shopify:section:load", function(event) {
    var body_tag = $('body');
    var section = $('#shopify-section-'+event.detail.sectionId+'');
    body_tag.trigger('lazyload-again', [section]);

    /* header section fixes */
    if (event.detail.sectionId == 'header') {
      $.getScript( "//cdn.shopify.com/s/files/1/0277/5230/0681/t/2/assets/async-scripts.js?v=95830710663977928401576601833" );
      if ($('.search-autocomplete').length > 0) {
        $('#formSearch input').keyup(function() {
          liveSearch($(this));
        });
      }
      body_tag.trigger('top-function');
    }

    /* product-template section fixes */
    if (event.detail.sectionId == 'product-template') {
      deliveryTimer();
    }

    /* banner grid section fixes */
    if (section.find('.banner-grid').length) {
      section.find('.cols').each(function() {
        $(this).isotope({masonry: {
          columnWidth: 1
        }});
      })
    }

    /* banner/slider section fixes */
    if (section.find('.banner-slider').length) {
      body_tag.trigger('owl-slider');
    }

    /* product slider section fixes */
    if (section.find('.product-slider').length) {
      body_tag.trigger('list-collection-slider');
      body_tag.trigger('put-in-tabs');
    }

    /* instafeed section fixes */
    if (section.find('.insta').length) {
      body_tag.trigger('load-insta');
    }

    /* collection page fixes */
    if (event.detail.sectionId == 'collection-template' ) {
      body_tag.trigger('pagination');
    }

    /* blog page fixes */
    if (event.detail.sectionId == 'blog-template' ) {
      body_tag.trigger('owl-slider');
      body_tag.trigger('blog-tags');
    }

    /* article page fixes */
    if (event.detail.sectionId == 'article-template' ) {
      body_tag.trigger('owl-slider');
      body_tag.trigger('blog-tags');
      body_tag.trigger('form-comment');
    }

    /* cart page fixes */
    if (event.detail.sectionId == 'cart-template' ) {
      body_tag.trigger('accordion');
      body_tag.trigger('ratings');
      body_tag.trigger('semantic-number');
      body_tag.trigger('input');
    }
    if (event.detail.sectionId == 'cart-product-recommendations' ) {
      body_tag.trigger('owl-slider');
    }
    if (event.detail.sectionId === "cart-product-recommendations") {
      loadProductRecommendationsIntoSection();
    }

    /* product page fixes */
    if (event.detail.sectionId == 'product-template' ) {
      body_tag.trigger('product-page-slider');
    }
    if (event.detail.sectionId == 'product-reviews' || event.detail.sectionId == 'product-recommendations' || event.detail.sectionId == 'product-tags' ) {
      body_tag.trigger('heading-rating');
    }
    if (event.detail.sectionId == 'recently-viewed-products' ) {
      body_tag.trigger('show-recently-viewed');
      body_tag.trigger('heading-rating');
    }
    if (event.detail.sectionId == 'product-recommendations' ) {
      if ($('.product-product-recommendations').length) {
        loadAll();
      }
      else if ($('.custom-recommended-container').length) {
        loadOnlyCustom();
      }
    }

  });

  document.addEventListener("shopify:block:select", function(event) {
    var section = $('#shopify-section-'+event.detail.sectionId+'');

    /* banner/slider section fixes */
    if (section.find('.banner-slider').length) {
      var slide = $('.block-'+event.detail.blockId+'').data('slide-index');
      section.find('.owl-carousel:first').trigger('to.owl.carousel', slide);
      section.find('.owl-carousel:first').trigger('stop.owl.autoplay');
    }

    /* product slider section fixes */
    /* faq section fixes */
    /* cart page fixes */
    if (section.find('.product-slider').length || section.find('.faq').length || section.find('.cart-container').length) {
      var tab = $('.block-'+event.detail.blockId+'');
      if (!tab.find('a.toggle').length || !tab.filter('.toggle')) {
        tab.find('a:first').trigger('click');
      }
    }

  });

  document.addEventListener("shopify:block:deselect", function(event) {
    var section = $('#shopify-section-'+event.detail.sectionId+'');

    /* product slider section fixes */
    /* faq section fixes */
    /* cart page fixes */
    if (section.find('.product-slider').length || section.find('.faq').length || section.find('.cart-container').length) {
      var tab = $('.block-'+event.detail.blockId+'');
      if (tab.find('a.toggle').length || tab.filter('.toggle')) {
        tab.find('a:first').trigger('click');
      }
    }
  });

  /* ------------- END SHOPIFY THEME EDITOR FIXES------------- */

  /* END CUSTOM JS */
})
